var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-the-modal-content-wrapper"},[_vm._t("modal-body")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }